import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../services/api.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {StorageService} from '../../services/storage.service';

@Component({
    selector: 'app-modal-alerta-aviso',
    templateUrl: './modal-alerta-aviso.component.html',
    styleUrls: ['./modal-alerta-aviso.component.scss']
})
export class ModalAlertaAvisoComponent implements OnInit {

    @Input() corPrimaria: string;
    @Input() title: string;
    @Input() text: any;
    @Input() conteudo: any;
    @Input() downloads: any;
    @Input() aplicativo: any;
    @Output() fecharModal = new EventEmitter();

    constructor(private toast: ToastrService,
                private api: ApiService,
                private loading: NgxSpinnerService,
                private storage: StorageService) {
    }

    ngOnInit() {
        //console.log('title: ', this.title);
        //console.log('text: ', this.text);
        //console.log('conteudo: ', this.conteudo);
        //console.log('downloads: ', this.downloads);
        //console.log('aplicativo: ', this.aplicativo);
    }

    fechar(bol) {
        this.fecharModal.emit();
    }

    adicionar() {
        this.fecharModal.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-alerta-aviso/modal-alerta-aviso.component.ts